/**
 * This tag has to match the API definition
 */
export const CRITICAL_INFORMATION_TAG = 'critical_information';
export const USER_NOTE_TAG = 'user_note';
export const USER_DOCUMENT_LINK_TAG = 'user_document_link';
export const UNPROCESSED_DOCUMENT_TAG = 'doc_unprocessed';

export type RecordTag =
	| typeof CRITICAL_INFORMATION_TAG
	| typeof USER_NOTE_TAG
	| typeof USER_DOCUMENT_LINK_TAG
	| typeof UNPROCESSED_DOCUMENT_TAG;

/**
 * Tags that are not considered files, but rather metadata or notes.
 */
export const NOT_A_FILE_TAGS: RecordTag[] = [CRITICAL_INFORMATION_TAG, USER_NOTE_TAG, USER_DOCUMENT_LINK_TAG];
